import { useTranslation } from "react-i18next";
import { BaseMobileHeader } from "@/common";
import { ProfileForm } from "@/entities/profile-form";
import { ChangeOldPasswordForm } from "@/entities/change-old-password-form";
import styles from "./styles.module.scss";

export const SettingsPageMobile = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <BaseMobileHeader showSorter={false} title={t("common.settings")} />
      <ProfileForm />
      <ChangeOldPasswordForm />
    </div>
  );
};
